module.exports = __webpack_public_path__ + "static/media/workforce_lg-desktop.58777574.png";